<template>
  <transition name="component-fade" mode="out-in">
    <div class="preloader">
      <div class="sk-folding-cube">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['loaded']
};
</script>
